// extracted by mini-css-extract-plugin
export var container = "_4i-0";
export var icon = "_4i-1";
export var text = "_4i-2";